module.exports = __webpack_public_path__ + "img/gabarito-4.b01d5185.png";